// extracted by mini-css-extract-plugin
export default {"input":"NumberInput_input__yQTJZ","div":"NumberInput_div__YLaF8","icon":"NumberInput_icon__H+UmS"};